export const getCompanyReport = (ggsId) => ({apis}) => {
  let payload = apis.getCompanyReport(ggsId).map((x) => x)
  return {
    type: 'GET_COMPANY_REPORT',
    payload,
  }
}



// WEBPACK FOOTER //
// ./src/store/report/actions.js